const utils = {}

utils.generatorName = (generator) => {
  let fullname = ''

  if (generator?.brand) {
    fullname += generator.brand + ' '
  }
  if (generator?.model) {
    fullname += generator.model + ' '
  }
  fullname = fullname.trim()

  return fullname
}

utils.implantName = (implant) => {
  const generators = utils.getGenerators(implant)

  let fullname = ''

  generators.forEach(generator => {
    fullname += utils.generatorName(generator) + "\n"
  })

  return fullname
}

utils.getGeneratorsTypes = () => [
  'generator_thermals',
  'generator_burners',
  'generator_recoverers',
  'generator_pumps',
  'generator_exchangers',
  'generator_cogenerators',
  'generator_solars',
  'generator_others'
]

utils.getGenerators = (implant, includeArchived = false) => {
  let generators = []

  utils.getGeneratorsTypes().forEach(type => {
    if (implant[type]?.length) {
      if (includeArchived) {
        generators = generators.concat(implant[type])
      } else {
        generators = generators.concat(implant[type].filter(gen => !gen.archived))
      }
    }
  })

  return generators
}

utils.calcTypes = (implant, code, implantGenerators) => {
  const check = (gens) => {
    if (implantGenerators?.length) {
      gens = gens.filter(gen => implantGenerators.some(impGen => impGen._id === gen._id))
    }

    if (gens?.length === 0) {
      return false
    }

    if (code) {
      return gens.find(gen => gen.code.trim() === code)
    } else {
      return true
    }
  }

  const types = []
  if (check(implant.generator_thermals)) {
    types.push('Gruppo termico')
  }
  if (check(implant.generator_burners)) {
    types.push('Bruciatore')
  }
  if (check(implant.generator_recoverers)) {
    types.push('Recuperatore / Condensatore')
  }
  if (check(implant.generator_pumps)) {
    types.push('Gruppo frigo / Pompa di calore')
  }
  if (check(implant.generator_exchangers)) {
    types.push('Scambiatore')
  }
  if (check(implant.generator_cogenerators)) {
    types.push('Cogeneratore / Trigeneratore')
  }
  if (check(implant.generator_solars)) {
    types.push('Campo solare')
  }
  if (check(implant.generator_others)) {
    types.push('Altro generatore')
  }

  return types
}

utils.getInstallers = (generators) => {
  let label = null

  if (generators?.length) {
    const gens = generators.filter(gen => gen.installer?.length)
    if (gens?.length) {
      label = gens.map(gen => gen.installer).join(', ')
    }
  }

  return label
}

export default utils